import { IAppConfig } from '../../config/appConfig/appConfig.types';
import { genMockDbData } from '../../mocks/generate';

/**
 * Mocking Service Integration
 */
export default class MockService {
  /** Initialize mock service worker */
  static async init(appConfig: IAppConfig): Promise<void> {
    if (!appConfig.isMock) {
      return;
    }

    const { worker } = await import('../../mocks/browser');
    await worker.start({
      onUnhandledRequest: (request) => {
        const { method, url } = request;
        /**
         * Mock service should be intercepting all calls from the following,
         * if any are missed, throw an error below
         */
        if (url.endsWith('/graphql')) {
          throw new Error(`Unhandled ${method} request to ${url}`);
        }
      },
    });

    // Generate all the mock data needed in the DB to run the app in Mock mode
    await genMockDbData();
  }
}
